import * as React from 'react';

import { cn } from '@mint-lib/tw-utils';
import { Popover as PopoverPrimitive } from 'radix-ui';

function Popover({
  ...props
}: Readonly<React.ComponentProps<typeof PopoverPrimitive.Root>>) {
  return <PopoverPrimitive.Root data-slot="popover" {...props} />;
}

function PopoverTrigger({
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Trigger>) {
  return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />;
}
function PopoverPortal({
  container,
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Portal> & {
  /**
   * Specify a container element to portal the content into.
   * @default document.body
   */

  container?: React.ComponentProps<typeof PopoverPrimitive.Portal>['container'];
}) {
  return (
    <PopoverPrimitive.Portal
      data-slot="popover-portal"
      {...props}
      container={container}
    />
  );
}

function PopoverContent({
  className,
  align = 'center',
  sideOffset = 4,
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Content>) {
  return (
    <PopoverPrimitive.Content
      data-slot="popover-content"
      align={align}
      sideOffset={sideOffset}
      className={cn(
        'relative overflow-hidden rounded-sm border border-ui-tertiary bg-ui-primary text-text-primary shadow-[0px_2px_4px_0px_rgba(9,30,66,0.16)] drop-shadow-[0px_0px_1px_0px_rgba(9,30,66,0.24)] outline-none',

        className,
      )}
      {...props}
    />
  );
}

function PopoverAnchor({
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Anchor>) {
  return <PopoverPrimitive.Anchor data-slot="popover-anchor" {...props} />;
}

export {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverAnchor,
  PopoverPortal,
};
